﻿/**
 * Class to work as a DTO to hold the information of a event dispatched to segment.
 * Read more at https://rangle.gitbook.io/redux-beacon/index/segment#identify
 */
class SegmentPageEvent {
  constructor(category, name, properties, options) {
    this.category = category;
    this.name = name;
    this.properties = properties;
    this.options = options;
  }

  /**
   * The above function returns the category of a segment page event.
   * @returns The category of the segment page event.
   */
  getCategory() {
    return this.category;
  }

  /**
   * The above function is a getter method that returns the value of the "name" property.
   * @returns The name property of the segment page event.
   */
  getName() {
    return this.name;
  }

  /**
   * The function returns the properties of a segment page event.
   * @returns The properties of the segment page event.
   */
  getProperties() {
    return this.properties;
  }

  /**
   * The function returns the options property.
   * @returns The options property is being returned.
   */
  getOptions() {
    return this.options;
  }
}

export default SegmentPageEvent;
